import { render, staticRenderFns } from "./viewObservationTemplate.vue?vue&type=template&id=4d05d3fa&"
import script from "./viewObservationTemplate.vue?vue&type=script&lang=js&"
export * from "./viewObservationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports